import { useMutation } from '@tanstack/react-query';

import { hubspotImportMatch } from './hubspotImportMatch';
import { type HubspotImportMatchMutationOptions } from './types';

/**
 * Mutation hook for uploading a HubSpot deal export and getting back the
 * supplier companies it matched, each with its match score.
 *
 * Nothing cached changes until the matches are applied, so this hook does not
 * invalidate any queries.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin---Companies/operation/post_hubspot_import_vadmin_company__company_id__hubspot_import_post
 */
export const useMutationHubspotImportMatch = (
  options?: HubspotImportMatchMutationOptions,
) =>
  // oxlint-disable-next-line react-doctor/query-mutation-missing-invalidation -- matching only reads; the apply mutation owns the invalidation
  useMutation({
    mutationFn: hubspotImportMatch,
    ...options,
  });
